import React, { FC } from 'react';

import LicenseStatusLabel from 'application/components/LicenseStatusLabel';

import { LicenseInfoTypeFragment } from '@entities/billing';

import Checkbox from '@zvuk-b2b/react-uikit/ui/Checkbox';

import styles from './index.module.scss';

interface LicenseModalProps {
  item: LicenseInfoTypeFragment;
  isChecked: boolean;
  isDisabled?: boolean;
  isGraceSubtitleVisible: boolean;
  isWaitPaymentSubtitleVisible: boolean;
  onChange: (value: boolean) => void;
}

const LicensesListItem: FC<LicenseModalProps> = ({
  item,
  isChecked,
  isDisabled = false,
  isGraceSubtitleVisible,
  isWaitPaymentSubtitleVisible,
  onChange,
}) => (
  <div className={styles.licensesListItem}>
    <div className={styles.addressContainer}>
      <span className={styles.addressContainerTitle}>{item.point?.address}</span>

      <LicenseStatusLabel
        paymentState={item.paymentState}
        autoRenewal={item.autoRenewal}
        expiresAt={item.expiresAt}
      />
    </div>

    <Checkbox
      elementId={`checkbox_license_${item.id}`}
      inputName={item.point?.address}
      isChecked={isChecked}
      isDisabled={isGraceSubtitleVisible || isWaitPaymentSubtitleVisible || isDisabled}
      onChange={onChange}
    />
  </div>
);

export default React.memo(LicensesListItem);
